export default "__VITE_ASSET__Bcy_7QLS__"